import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import ActionCarousel from "@/components/ActionCarousel";
import { SERVICE_CATALOG } from "@/lib/serviceCatalog";

const humanSpecies = (slug) => {
  const s = (slug || "").toLowerCase();
  if (s === "equine") return "Equine";
  if (s === "canine") return "Canine";
  if (s === "feline") return "Feline";
  if (s === "cattle") return "Cattle";
  if (s === "exotics") return "Exotics";
  return "Services";
};

const buildServiceCards = (species) => {
  const s = (species || "").toLowerCase();
  return SERVICE_CATALOG
    .filter((item) => item.species.includes(s))
    .map((item) => ({
      title: item.title,
      subtitle: `Serving ${humanSpecies(s)}`,
      actions: [
        { label: `Find a ${item.title}`, href: `/browse/${s}/services/find?type=${item.type}` },
        { label: `Register as a ${item.title}`, href: `/browse/${s}/services/register?type=${item.type}` },
      ],
    }));
};

const BrowseServices = () => {
  const location = useLocation();
  const species = location.pathname.split('/')[2]; // /browse/:species/services

  const cards = useMemo(() => buildServiceCards(species), [species]);

  return (
    <div className="pt-24 pb-16 px-6 md:px-12 min-h-screen bg-[#050505]">
      <div className="max-w-7xl mx-auto">
        <ActionCarousel subtitle="Services" title={`${humanSpecies(species)} Providers`} cards={cards} />
      </div>
    </div>
  );
};

export default BrowseServices;
